import React, { useState } from "react";
import {
  Box,
  Grid2,
  TextField,
  Typography,
  Button,
  InputAdornment,
  Paper,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
// import { encode as base64_encode} from 'base-64';

import PSPLOGO from "../../Images/Nav/PSPLOGO.png";
import { toast } from "react-toastify";
// import Cookie from "js-cookie";

import { useDispatch } from "react-redux";
import { axiosPrivate } from "../../axios/axios";
import ErrorProps from "../../Component/Errorprops";
import { api } from "../API/config";
import { commonCss } from "../../StyleConfig/CommonCss";
import { getOTPAndEmail } from "../../Redux/authentication";

const GetEmail = () => {
  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialValues = {
    emailId: "",
  };
  const onSubmit = (values, { resetForm }) => {
    setLoading(true);
    const getLink = api.account.forgetPassword;
    axiosPrivate
      .post(`${getLink}`, values)
      .then((res) => {
        // dispatch({type:"reset",payload:{email:values.email,code:base64_encode(res.data.data)}})
        dispatch(getOTPAndEmail({emailId:values.emailId}))
        toast.success("Please Check Your Email For OTP");
        setLoading(false);
        navigate("/setpassword");
        // if(res.data.data.userRole===4){
        //   navigate("/user")

        // }else{
        //   navigate("/reportform")
        // }

        resetForm();
      })
      .catch((err) => {
        toast.error(
                          <Box sx={{display:"flex",flexDirection:'column'}}>
                            {
                              err.response.data.errors!==null?
                                               err.response.data.errors.map((d,i)=>(
                                                 <Typography key={i}>{i+1+". "+d.errorMessage}</Typography>
                              )):err.response.data.message
                            }
                          </Box>
                          )
        console.log(err)
        setLoading(false);
      });
  };
  const validationSchema = Yup.object({
    emailId: Yup.string()
      .required("Email is required")
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "Invalild Email"
      ),
  });
  return (
    <Box
      sx={{
        background: commonCss.normalLinearGradient,
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{
          background: commonCss.shadeLinearGradient,
          p: 1,
          borderRadius: "1.5rem",
          width: "50%",
        }}
      >
        <Grid2 container>
          <Grid2
            container
            item
            xs={12}
            md={12}
            sx={{ padding: { xs: "2rem" } }}
            gap="1.5rem"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "1.8rem",
              }}
            >
              <Link to="/">
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
                >
                  <img
                    style={{ width:"4vw",height:"8vh" }}
                    src={PSPLOGO}
                    alt="logo"
                  />
                  <Typography
                    variant="h6"
                    noWrap
                    sx={{ fontSize: "1.4rem", color: "#ffbe0b", mt: -1 }}
                  >
                    <span style={{ color: commonCss.green }}>e</span> - PTW
                  </Typography>
                </Box>
              </Link>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
              >
                <Typography sx={{ fontWeight: 400, fontSize: "1.1rem" }}>
                  Reset Password
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "#6C7585" }}>
                  Enter your email address and we'll send you an email with
                  instructions to reset your password.
                </Typography>
              </Box>
            </Box>
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
            >
              <Form
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.7rem",
                  width: "100%",
                }}
              >
                <Typography sx={{ color: commonCss.labelInputColor, fontWeight: 500  }}>
                  Email
                </Typography>
                <Field
                  as={TextField}
                  type="emailId"
                  fullWidth
                  size={"large"}
                  name="emailId"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: commonCss.inputBackgroundColor,
                      borderRadius: commonCss.inputBorderRadius,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: commonCss.inputBorderColor,
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AlternateEmailIcon
                          sx={{ color: commonCss.green, fontWeight: 1800 }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                <ErrorMessage name="emailId">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>

                <Button
                  type="submit"
                  variant="contained"
                  disabled={isLoading}
                  fullWidth
                  sx={{
                    padding: "0.5rem",
                    mt: "0.7rem",
                    color: "white",
                    background: isLoading
                      ? "default"
                      : commonCss.normalLinearGradient,
                    "&:hover": {
                      backgroundColor: isLoading ? "default" : commonCss.red,
                    },
                  }}
                >
                  Submit
                </Button>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: "1.5rem",
                  }}
                >
                  <Typography sx={{ color: "#6C757D" }}>
                    Back to{" "}
                    <Link
                      to="/"
                      style={{
                        textDecoration: "none",
                        color: commonCss.green,
                        fontWeight: 600,
                      }}
                    >
                      Log in
                    </Link>
                  </Typography>
                </Box>
              </Form>
            </Formik>
          </Grid2>
        </Grid2>
      </Paper>
    </Box>
  );
};

export default GetEmail;
